<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-overlay :value="!loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-form id="uploaddocuments_form" @submit.prevent="submit" v-model="isValid">
      <v-card class="box">
        <v-row dense justify="center">
          <v-col cols="10" sm="10" md="10">
            <v-alert type="warning" text prominent>
              <strong>Note: </strong>
              <ul>
                <li>{{ file_upload_config.allowed_type }}</li>
                <li>
                  Size of uploading documents should be <= {{ file_upload_config.max_size / 1000000 }} MB </li>
              </ul>
            </v-alert>
          </v-col>
        </v-row>

        <v-row dense justify="center">
          <v-col cols="4" sm="4" md="4">
            <template>
              <v-file-input :rules="[
                  (v) =>
                    !!v ||
                    'File is required' ||
                    v.length < file_upload_config.max_size,
                ]" :required="true" :accept="file_upload_config.allowed_type" :placeholder="`Upload file size limit ${
                  file_upload_config.max_size / 1000000
                } MB!`" rounded dense outlined prepend-icon="mdi-attachment" label="Choose File" show-size
                v-model="file" name="doc"></v-file-input>
            </template>
          </v-col>

          <v-col cols="2" sm="2" md="2">
            <v-btn class="mt-0 button" @click="submit" :disabled="!isValid">
              <v-icon dark> mdi-cloud-upload </v-icon> Upload
            </v-btn>
          </v-col>
          <v-col cols="4" sm="4" md="4">
            <template v-if="attachment != '-'">
              <a target="_blank" :href="basepath + attachment">Current Instruction File</a>
              <v-btn text title="Delete attachment" :loading="delete_load" @click="deleteAttachment()">
                <v-icon color="red">mdi-window-close</v-icon>
              </v-btn>
            </template>
          </v-col>
        </v-row>
      </v-card>
    </v-form>
    <div style="display: flex; justify-content: center">
      <div class="center" style="font-size: 20px; font-style: italic; font-weight: bold">
        OR
      </div>
    </div>
    <v-card>
      <v-toolbar flat dense class="toolbar" align="center" justify="center">
        <v-toolbar-title>Admission Instruction</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-col>
        <!-- <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Admission Instruction Points
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar> -->
        <!-- <v-col> -->
        <v-card-text>
          <v-card>
            <!-- <v-card-title>Admission Instruction Points</v-card-title> -->
            <v-card-text>
              <!-- <v-col> -->
              <v-textarea outlined name="input-7-4" label="Customise your Admission Instruction Points..." auto-grow
                v-model="admission_instruction_points" ref="ta"></v-textarea>
              <center>
                <v-btn color="primary" :loading="loader1" @click="save_admission_inst_points">Save Instruction
                  Points</v-btn>
              </center>
              <!-- </v-col> -->
            </v-card-text>
          </v-card>
        </v-card-text>
        <!-- </v-col> -->
        <!-- <v-col> -->
        <v-card-text>
          <v-card>
            <v-card-title>Instruction Points Preview</v-card-title>
            <v-card-text>
              <!-- {{template}} -->
              <div id="preview" ref="content" v-html="admission_instruction_points"></div>
              <!-- <img :src="output"> -->
              <!-- <div v-html="template"></div> -->
            </v-card-text>
          </v-card>
        </v-card-text>
        <!-- </v-col> -->
      </v-col>
    </v-card>
    <br />
    <v-card>
      <v-toolbar flat dense class="toolbar" align="center" justify="center">
        <v-toolbar-title>Admission CheckList</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-col>
        <!-- <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Admission Instruction Points
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar> -->
        <!-- <v-col> -->
        <v-card-text>
          <v-card>
            <!-- <v-card-title>Admission CheckList</v-card-title> -->
            <v-card-text>
              <!-- <v-col> -->
              <v-textarea outlined name="input-7-4" label="Customise your Admission CheckList..." auto-grow
                v-model="admission_checklist" ref="ta"></v-textarea>
              <center>
                <v-btn color="primary" :loading="loader2" @click="save_admission_checklist">Save Admission
                  CheckList</v-btn>
              </center>
              <!-- </v-col> -->
            </v-card-text>
          </v-card>
        </v-card-text>
        <!-- </v-col> -->
        <!-- <v-col> -->
        <v-card-text>
          <v-card>
            <v-card-title>CheckList Preview</v-card-title>
            <v-card-text>
              <div id="preview" ref="content" v-html="admission_checklist"></div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <!-- </v-col> -->
      </v-col>
    </v-card>
    <!-- <v-card class="box">
           <v-toolbar flat dense class="toolbar" align="center" justify="center">
                        <v-toolbar-title>Instructions</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
           </v-toolbar>
            <v-data-table :items="admission_instruction" :headers="headers" class="elevation-1 mytable" dense :search="search">
                <template v-slot:top>
                    <v-toolbar flat dense color="white" align="center" justify="center">
                         <v-toolbar-title>Instructions</v-toolbar-title>

                        <v-divider class="mx-4" inset vertical></v-divider> 
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details class="no-display"></v-text-field>
                    </v-toolbar>
                </template>
                <template v-slot:item.view="{item}">
                    <div>
                        <v-btn class="button" small icon @click="viewFile(item)" title="View File">
                             <v-icon left>mdi-email-send-outline</v-icon> 
                            <v-icon size="20">mdi-file-document</v-icon>
                        </v-btn>
                    </div>
                </template>
                <template v-slot:item.delete="{item}">
                    <div>
                        <v-btn color="error" rounded outlined small icon dark :loading="delete_btn_load" @click="deleteInstruction(item.id)" title="Delete File">
                             <v-icon left>mdi-email-send-outline</v-icon> 
                            <v-icon size="20">mdi-delete-empty</v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card> -->
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    admission_instruction_points: null,
    admission_checklist: null,
    attachment: "",
    isValid: true,
    loader: false,
    loader1: false,
    loader2: false,
    delete_load: false,
    basepath: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    // extraBreadcrumbItems: [
      
    // ],
    // breadcrumbClass: "breadcrumb-style1",
    search: "",
    file_upload_config: { allowed_type: "", max_size: 1000 },
    file: null,
    delete_btn_load: false,
    admission_instruction: [],
    awspath: null,
    headers: [
      { text: "Instruction", value: "documentname", sortable: true },
      { text: "View", value: "view", sortable: false },
      { text: "Delete", value: "delete", sortable: false },
    ],
  }),
  methods: {
    deleteAttachment() {
      if (!confirm("Are you sure you want to delete this instruction file?"))
        return;
      this.delete_load = true;
      axios
        .post("/Admission/deleteInstructions_new")
        .then((res) => {
          this.delete_load = false;
          if (res.data.status == "YES") {
            this.showSnackbar(
              "#4caf50",
              "Instructions deleted successfully..."
            ); // show snackbar on success
            this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar
            //alert(res.data.status_reason)
          }
        })
        .catch((error) => {
          this.delete_load = false;
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.delete_load = false;
        });
    },
    save_admission_inst_points() {
      this.overlay = true;
      this.loader1 = true;
      const data = {
        admission_instruction_points: this.admission_instruction_points,
      };
      axios
        .post("/Admission/save_admission_instruction_points", data)
        .then((res) => {
          this.overlay = false;
          this.loader1 = false;
          if (res.data.flag == "YES") {
            this.showSnackbar(
              "success",
              "Admission Instruction Points Saved successfully..."
            );
          } else {
            this.overlay = false;
            this.loader1 = false;
            this.showSnackbar(
              "error",
              "Cannot save Admission Instruction Points, please try again later!"
            );
          }
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
          this.loader1 = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader1 = false;
        });
    },
    save_admission_checklist() {
      this.overlay = true;
      this.loader2 = true;
      const data = {
        admission_checklist: this.admission_checklist,
      };
      axios
        .post("/Admission/save_admission_checklist", data)
        .then((res) => {
          this.overlay = false;
          this.loader2 = false;
          if (res.data.flag == "YES") {
            this.showSnackbar(
              "success",
              "Admission Checklist saved successfully..."
            );
          } else {
            this.overlay = false;
            this.loader2 = false;
            this.showSnackbar(
              "error",
              "Cannot save Admission Checklist, please try again later!"
            );
          }
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
          this.loader2 = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader2 = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    submit() {
      this.loader = false;
      var form = document.getElementById("uploaddocuments_form");
      var formData = new FormData(form);

      if (this.file) {
        axios
          .post("admission/saveUploadInstructionDocument", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(
            (response) => {
              // success callback

              if (response.data.form_saved == "YES") {
                this.showSnackbar("#4caf50", "File Saved Successfully...!"); // show snackbar on success
                this.loader = true;
                this.file = null;
                this.onLoad();
              }
            },
            (response) => {
              // error callback
            }
          );
      } else {
        this.showSnackbar("#b71c1c", "Choose file !!!"); // show snackbar on error
      }
    },
    viewFile(item) {
      this.awspath = localStorage.getItem("awspath");
      this.editItemIndex = this.admission_instruction.indexOf(item);
      //return this.awspath+this.admission_instruction.documentpath
      window.open(this.awspath + item.documentpath + item.documentname);
    },
    deleteInstruction(attach) {
      if (!confirm("Are you sure you want to delete this item?")) return;
      const data = {
        attach_id: attach,
      };
      this.delete_acttach_load = true;
      axios
        .post("/Admission/deleteInstructions", data)
        .then((res) => {
          if (res.data.status == "YES") {
            const index = this.admission_instruction.indexOf(attach);
            this.admission_instruction.splice(index, 1);
            this.showSnackbar(
              "#4caf50",
              "Instructions deleted successfully..."
            ); // show snackbar on success
            this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
            //alert(res.data.status_reason)
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.delete_acttach_load = false;
        });
    },
    onLoad() {
      axios
        .get("admission/admissionInstrution")
        .then((res) => {
          if (res.data.msg == "200") {
            this.loader = true;
            this.file_upload_config = res.data.file_upload_config;
            this.admission_instruction = res.data.admission_instruction;
            this.admission_instruction_points = res.data.admission_instructions;
            this.attachment = res.data.attachment;
            this.admission_checklist = res.data.admission_checklist;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onLoad();
    this.basepath = localStorage.getItem("awspath");
  },
};
</script>
<style scoped>


.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
